import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// images
import financialPlanningImageDesktopWebp from './images/tim-gerend-speaking-publicly.webp';
import financialPlanningImageMobileWebp from './images/tim-gerend-speaking-publicly-mobile.webp';
// styles
import { LinkStyled } from './styles';

export default () => {
  return (

    <InformationalModule
      // configs
      sectionId='who-we-are-financial-planning-6'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={<> We believe in leading <WidowBlock>by example.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='link'>
            From our CEO to our Board of Trustees, our leaders live and breathe the principles Northwestern Mutual was founded on: doing what&#39;s right for our clients, taking the long view, delivering superior product value, building lifelong relationships, and maintaining exceptional financial strength. And they inspire the rest of our employees and advisors to do the same.
          </Typography>
          <LinkStyled
            id='who-we-are-our-leaders-link'
            variant='buttonLinkTertiary'
            endAdornment={CaratRight}
            endAdornmentStylesReset
            linkUrl='/leaders/'>
            More about our leaders
          </LinkStyled>
        </>
      )}
      // image props
      imageAltText='Northwestern Mutual CEO Tim Gerend'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />

  );
};
